<template>
  <div ref="wrap" class="header-wrap" :class="[isHome?'home':'']">
    <div class="mask"></div>
    <div class="header auto1200">
      <a href="/" class="logo">
        <img src="../assets/img/logo_tab.png">
      </a>
      <el-menu
        :default-active="activeIndex"
        background-color="#151515"
        text-color="#f1f1f1"
        active-text-color="#0d70c6"
        mode="horizontal"
      >
        <el-menu-item index="1">
          <router-link :to="{name: 'home'}">首页</router-link>
        </el-menu-item>
        <el-menu-item index="2">
          <router-link :to="{name: 'process'}">入驻流程</router-link>
        </el-menu-item>
        <el-menu-item index="3">
          <router-link :to="{name: 'rule'}">入驻规则</router-link>
        </el-menu-item>
      </el-menu>
      <div class="nav-box">
        <div v-if="loginStatus" class="user-info">
          <span class="name">{{ userInfo.userName }}</span>
          <span @click="logout">退出</span>
        </div>
        <div v-else class="login" @click="login">登录</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState, mapActions } from 'vuex'

export default {
  props: {
    msg: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      userInfo: {},
      isHome: false
    }
  },

  computed: {
    ...mapState({
      loginStatus: state => state.loginStatus
    }),
    activeIndex() {
      const { name } = this.$route
      switch (name) {
        case 'home':
          return '1'
        case 'process':
          return '2'
        case 'rule':
          return '3'
        case 'apply':
          return '0'
        default:
          return '1'
      }
    }
  },
  watch: {
    '$route': {
      handler(to) {
        this.isHome = to.name === 'home'
        this.$nextTick(() => {
          if (!this.isHome) {
            this.$refs.wrap.style.backgroundColor = `rgba(21,21,21,1)`
          } else {
            this.$refs.wrap.style.backgroundColor = `rgba(21,21,21,0)`
          }
        })
      },
      immediate: true
    }
  },
  async mounted() {
    this.getLoginStatus().then(res => {
      if (!res.code) {
        this.userInfo = res.data
      }
      document.addEventListener('scroll', this.handleScroll, true)
    })
  },
  methods: {
    ...mapMutations({
      setLoginStatus: 'LOGIN_STATUS'
    }),
    ...mapActions(['getLoginStatus']),
    login(e) {
      e && e.preventDefault()
      location.href =
        '/app/shop/login?followup=' + encodeURIComponent(location.href)
    },
    logout(e) {
      e && e.preventDefault()
      location.href =
        '/app/shop/logout?followup=' + encodeURIComponent(location.origin)
    },
    /**
     * @name handleScroll
     * @description 页面滚动事件处理函数
     */
    handleScroll() {
      if (!this.isHome) return
      const scrollTop = document.getElementById('main').scrollTop
      const maxHeight = 100
      if (scrollTop < maxHeight) {
        const scale = 1.0 - (maxHeight - scrollTop) / maxHeight
        this.$refs.wrap.style.backgroundColor = `rgba(21,21,21, ${scale})`
      } else {
        this.$refs.wrap.style.backgroundColor = `rgba(21,21,21,1)`
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
.header-wrap {
  position: relative;
  height: 60px;
  background: #151515;
  opacity: 0.9;
  background-size: 20px 100%;
  padding: 0 0 1px 0;
  color: #f1f1f1;
  // box-shadow: 0 1px 1px 1.5px rgba(0, 0, 0, 0.2);

  &.home {
    background-color: rgba(21,21,21,0);

    ul.el-menu {
      background-color: rgba(21,21,21,0) !important;

      li.el-menu-item {
        background-color: rgba(21,21,21,0) !important;
        display: flex;
        justify-content: center;

        &.is-active {
          border-bottom: none;

          &:before {
            content: '';
            position: absolute;
            bottom: 0;
            width: 70%;
            height: 3px;
            background: #fff;
          }

          a {
            color: #fff;
            font-weight: 700;
          }
        }

        a {
          cursor: pointer;

          &:hover {
            background-color: rgba(0,0,0,0.3);
          }
        }
      }
    }
  }

  .user-info {
    display: flex;
    align-items: center;
    i,
    img {
      width: 40px;
      height: 40px;
      font-size: 40px;
      border-radius: 50%;
    }
  }

  .header {
    line-height: 60px;
    margin: 0 auto;
    overflow: hidden;
    content: '';
    display: block;
    clear: both;
    position: relative;
    z-index: 1;

    .logo {
      height: 60px;
      float: left;
      display: flex;
      align-items: center;
      font-size: 19px;
      font-weight: bold;
      color: rgba(118, 96, 78, 1);
      margin-right: 30px;
      margin-left: 40px;

      .logo-img {
        width: 94px;
        height: 26px;
        margin-right: 5px;
        background: url(../assets/img/logo_tab.png);
        background-size: 100% 100%;
      }
    }

    .el-menu {
      float: left;
      border-bottom: 0;
      .el-menu-item {
        padding: 0;
        a {
          height: 60px;
          display: block;
          padding: 0 20px;
          color: #f1f1f1;
        }
      }

      .is-active {
        a {
          font-weight: bold;
          color: #0d70c6;
          font-size: 16px;
          font-weight: bolder;
        }
      }
    }

    .nav-box {
      float: right;
      display: flex;
      font-weight: bold;
      font-size: 16px;

      .icon-box {
        display: flex;
        align-items: center;
        cursor: pointer;
        i {
          font-size: 24px;
          margin-right: 3px;
        }
      }

      .login {
        width: 60px;
        text-align: center;
        cursor: pointer;
      }
    }
  }
}

.dropdown-login {
  width: 100px;
  line-height: 40px;
  padding-top: 12px;
}
.user-info {
  text-align: center;
  cursor: pointer;
  .pic {
    border-radius: 50%;
  }
  .name {
    padding-left: 4px;
    font-weight: bold;
    margin-right: 10px;
  }
}
.user-center {
  color: #606266;
  text-decoration: none;
}
</style>
